<template>
    <div :class="$style.root">
        <div class="announcement-box">

        </div>
    </div>
</template>

<script>
    export default {
        name: 'AnnouncementView',
    };
</script>
<style lang="less" module>
    .root {
        width: 100%;
        height: 40px;
        background: #f0f3f9;

        :global {
            .announcement-box {
                max-width: 1180px;
                margin: auto;

                .title {
                    width: 100%;
                    height: 40px;
                    line-height: 40px;
                    font-size: 16px;
                    color: #435573;
                    margin-bottom: 10px;
                    padding-top: 10px;
                }

                .ant-row {
                    line-height: 50px;

                    .a-col {
                        display: flex;
                        background: url(../../../../src/assets/li-head.png) no-repeat left;
                        padding-left: 25px;
                    }
                }
            }
        }
    }
</style>
